import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- Performance hints: inject as early as possible ---
// Preconnect to image CDN and preload the hero image so the LCP starts
// downloading before React even mounts.
if (typeof document !== 'undefined') {
  const head = document.head;
  const addLink = (attrs: Record<string, string>) => {
    // Avoid duplicates on hot reload
    const selector = `link[data-perf="${attrs['data-perf']}"]`;
    if (document.querySelector(selector)) return;
    const link = document.createElement('link');
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    head.appendChild(link);
  };
  // Preconnect to image CDN
  addLink({
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com',
    crossorigin: '',
    'data-perf': 'preconnect-cdn'
  });
  addLink({
    rel: 'dns-prefetch',
    href: 'https://cdn.magicpatterns.com',
    'data-perf': 'dns-cdn'
  });
  // Preconnect to Meta Pixel (so it loads quickly when we trigger it)
  addLink({
    rel: 'dns-prefetch',
    href: 'https://connect.facebook.net',
    'data-perf': 'dns-fb'
  });
  // Preload the hero image (LCP) — highest priority
  addLink({
    rel: 'preload',
    as: 'image',
    href: 'https://cdn.magicpatterns.com/uploads/93NHYJDcxU4RYRJXsfahF1/94.png',
    fetchpriority: 'high',
    'data-perf': 'preload-hero'
  });
}
render(<App data-id="element-264" />, document.getElementById('root'));